import { render, staticRenderFns } from "./UsageBillTotalTopTenPieChart.vue?vue&type=template&id=b5a32dfc&scoped=true&"
import script from "./UsageBillTotalTopTenPieChart.vue?vue&type=script&lang=js&"
export * from "./UsageBillTotalTopTenPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5a32dfc",
  null
  
)

export default component.exports